// Copyright (c) 2026. Hardfin, Inc. All rights reserved.

/**
 * What the third party said it was shipping on an outbound line.
 *
 * Held units are excluded from the line's quantity, so a line the 3PL reported
 * 14 units for, 4 of which were held, reads as planned 10 against 10 serials —
 * as though the 4 were never reported. Add them back.
 *
 * This is a stand-in until shipment_items.requested_quantity is populated
 * (#15138), which will carry what was asked for directly rather than inferring
 * it from what survived.
 */
export function outboundPlannedQuantity(
  quantity: number | null,
  quarantinedQuantity: number
): number | null {
  if (quantity === null) {
    return quarantinedQuantity > 0 ? quarantinedQuantity : null;
  }
  return quantity + quarantinedQuantity;
}
